import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import InvoiceView from "@/components/InvoiceView";

export default function PublicInvoice() {
  const { oid } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/public/invoice/${oid}`)
      .then((r) => setData({ order: r.data.order, biz: r.data.business, pay: r.data.payment }))
      .catch(() => setData(false));
  }, [oid]);
  if (data === false) return <div style={{ padding: 40, fontFamily: "Arial" }}>Invoice not found.</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Loading invoice…</div>;
  const pay = data.pay || {};
  const due = Number(data.order?.total || 0);
  const upiLink = pay.upi_id ? `upi://pay?pa=${encodeURIComponent(pay.upi_id)}&pn=${encodeURIComponent(pay.merchant_name || "")}${due ? `&am=${due}` : ""}&cu=INR` : null;
  return (
    <div>
      {pay.upi_id && (
        <div className="no-print" style={{ maxWidth: 760, margin: "16px auto 0", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 12, padding: 16, fontFamily: "Arial" }} data-testid="invoice-upi-box">
          <div style={{ fontSize: 13, color: "#6d28d9", fontWeight: 700 }}>Pay via UPI</div>
          <div style={{ fontSize: 15, fontWeight: 800, color: "#4c1d95", marginTop: 2 }} data-testid="invoice-upi-id">{pay.upi_id}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{pay.merchant_name}{due ? ` · ₹${due.toLocaleString("en-IN")}` : ""}</div>
          {upiLink && <a href={upiLink} data-testid="invoice-upi-pay" style={{ display: "inline-block", marginTop: 8, background: "#7c3aed", color: "#fff", fontWeight: 700, fontSize: 13, padding: "8px 14px", borderRadius: 8, textDecoration: "none" }}>Open UPI App</a>}
        </div>
      )}
      <InvoiceView order={data.order} biz={data.biz} />
    </div>
  );
}
